import { useState, useEffect } from 'react';
import { auth, functions } from '../FirebaseAuthConfig';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { httpsCallable } from 'firebase/functions';

// import googleIcon from '../assets/googleIcon.png';
// import phoneIcon from '../assets/phone.fill.png';
// import cancelIcon from '../assets/chevron.backward.png';
import challengeHeader from '../assets/TEXT.png';

import Loader from '../Pages/loader.js';
import AuthWithPhone from './AuthWithPhone.js';

const provider = new GoogleAuthProvider();

function Auth() {
    const countryCode = '+1';

    const [phoneNumber, setPhoneNumber] = useState(countryCode);
    const [showPhone, setShowPhone] = useState(false);

    const [isLoading, setIsLoading] = useState(false);
    const [gError, setGError] = useState(false);
    const [currentAuthUser, setCurrentAuthUser] = useState(null);
    const [registered, setRegistered] = useState(false);

    useEffect(() => {
        let unsubscribe = auth.onAuthStateChanged((currentUser) => {
            if (currentUser) {
                setCurrentAuthUser(currentUser);

                const checkUser = httpsCallable(functions, 'checkForUser');
                checkUser().then((response) => {
                    var resultData = response.data;

                    if (resultData.result === 'userExists - ISregistered') {
                        console.log('Found user');

                        // window.location.replace('/');
                        setRegistered(true);
                        setIsLoading(false);

                        return 'Completed. Found Auth.';
                    } else {
                        return 'Completed. No Auth discovered.';
                    }
                });
            } else {
                return;
            }
        });
        return () => {
            unsubscribe();
        };
    }, []);

    const signInWithGoogle = () => {
        setIsLoading(true);
        setGError(false);

        signInWithPopup(auth, provider)
            .then((result) => {
                // const credential = GoogleAuthProvider.credentialFromResult(result);
                // const token = credential.accessToken;

                const user = result.user;
                var email = user.email;

                if (email.includes('@elevationchurch.org') || email.includes('@elevationcollege.com')) {
                    console.log('Communicating with SF');
                    salesForceCheck(true, user);
                } else if (email.includes('@elevationchurch.ca') || email.includes('@stevenfurtick.com')) {
                    checkForUser(true, user, false);
                } else {
                    setIsLoading(false);
                    setGError(true);
                }

                // window.location.replace('http://localhost:3000/home');
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                console.log(`Error Code: ${errorCode} | Error Message: ${errorMessage}`);

                setIsLoading(false);
                alert('Error: Please try again.');
            });
    };

    const handlePhoneVerified = (user) => {
        salesForceCheck(false, user);
    };

    const salesForceCheck = (isGoogle, userData) => {
        const checkSF = httpsCallable(functions, 'getProfile');
        checkSF().then((result) => {
            console.log(result.data);
            if (!result.data || result.data.exists === false || (!result.data.spouse && !result.data.staff)) {
                console.log('User does not exist in SF');

                setShowPhone(false);
                setPhoneNumber('+1');
                setIsLoading(false);

                alert('Account Not Found. Please try again.');
            } else if (result.data.exists === true || result.data.exists === undefined) {
                let nonStaffSpouse = result.data.spouse && !result.data.staff;
                var newEmailAddress = result.data?.email || '';
                let newUserData = isGoogle
                    ? userData
                    : {
                          uid: userData.uid,
                          displayName: result.data.display_name,
                          email: newEmailAddress,
                          firstName: result.data.first_name,
                          lastName: result.data.last_name,
                          phoneNumber: phoneNumber,
                          photoURL: '',
                      };
                checkForUser(isGoogle, newUserData, nonStaffSpouse);
            }
        });
    };

    async function checkForUser(isGoogle, userData, nonStaffSpouse) {
        var newEmailAddress = userData?.email || '';
        var newPhoneNumber = userData?.phoneNumber || '';
        var newProfilePic = userData?.photoURL || '';
        var newFirstName = '';
        var newLastName = '';
        var displayName = `${userData.displayName}`;
        var namePieces = [];

        const checkUser = httpsCallable(functions, 'checkForUser');
        checkUser()
            .then((result) => {
                var resultData = result.data;
                console.log(resultData);

                if (resultData.result === 'userExists - ISregistered') {
                    console.log('Found user');

                    // window.location.replace('/');
                    setRegistered(true);
                    setIsLoading(false);
                } else if (resultData.result === 'userExists - NOTregistered') {
                    console.log('Found non-registered user');

                    document.cookie = `non_staff_spouse=${nonStaffSpouse}`;
                    window.location.replace('/register');
                } else if (resultData.result === 'noUserFound') {
                    console.log('New user. Creating Account.');

                    newEmailAddress = userData?.email || '';
                    newPhoneNumber = userData?.phoneNumber || '';
                    newProfilePic = userData?.photoURL || '';

                    if (userData?.firstName === undefined || userData?.firstName === '') {
                        namePieces = [];
                        namePieces = displayName.split(' ');

                        newFirstName = namePieces[0];
                        newLastName = namePieces[1];
                    } else {
                        newFirstName = userData.firstName;
                        newLastName = userData.lastName;
                    }

                    const newUserData = {
                        authWithGoogle: isGoogle,
                        displayName: userData.displayName,
                        email: newEmailAddress,
                        firstName: newFirstName,
                        lastName: newLastName,
                        phone: newPhoneNumber,
                        profilePic: newProfilePic,
                    };

                    const createUser = httpsCallable(functions, 'createUserWithFB');
                    createUser({ data: newUserData })
                        .then((createResult) => {
                            var callback = createResult.data;
                            console.log(callback);

                            if (callback.result === 'userCreated') {
                                document.cookie = `non_staff_spouse=${nonStaffSpouse}`;
                                window.location.replace('/register');
                            } else {
                                setShowPhone(false);
                                setPhoneNumber('+1');
                                setIsLoading(false);

                                alert('Error. Unable to register your account. Please try again later.');
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                } else if (resultData.result === 'userExistsInQuery') {
                    // var path = `${resultData.path}`;
                    // var userUID = path.slice(path.lastIndexOf('/')+1);

                    // window.location.replace('http://localhost:3000/home');
                    window.location.replace('/'); // TODO: Change back to '/' when challenge goes live

                    setShowPhone(false);
                    setPhoneNumber('+1');
                    setIsLoading(false);

                    alert('You already have an account. Please try a different sign in method.');
                } else {
                    console.log('Error');
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const phoneButtonPressed = () => {
        setShowPhone(true);
    };

    const cancelButtonPressed = () => {
        setShowPhone(false);
        setPhoneNumber('+1');
    };

    // const openRules = () => {
    //     window.open('https://immeasurablysore.com/rules', '_blank');
    // };

    const techTicket = () => {
        window.open(
            'https://staff.elevationchurch.org/support/tickets/new?category=Software&sub_category=Account%20Access&subject=Everyday%20WAR-Ship%20-%20Auth%20Support',
            '_blank'
        );
    };

    return (
        <div className="w-screen h-screen bg-[#350A14] flex flex-col justify-center items-center">
            <div className="w-[90%] sm:w-1/2 h-screen flex flex-col justify-center items-center">
                <div className="flex flex-col justify-center items-center gap-2 mb-8">
                    {/* <h3 className="font-sans font-normal text-[25px] text-[#d8a051]">Welcome to</h3> */}
                    <img className="w-full" src={challengeHeader} alt="" />
                </div>
                {showPhone === true && <AuthWithPhone onVerified={handlePhoneVerified} cancelled={cancelButtonPressed} />}
                {showPhone === false && registered === false && (
                    <div className="min-w-96 h-fit gap-2 flex flex-col justify-center items-center">
                        <button
                            className="w-96 h-12 px-4 border-none rounded-2xl bg-[#FF671F] font-sans text-xl font-semibold tracking-[0.1rem] text-white text-center"
                            onClick={signInWithGoogle}
                        >
                            Sign in as Staff
                        </button>
                        {gError === true ? (
                            <h3 className="font-sans font-normal text-base text-white">Please sign in with an Elevation Church Google account.</h3>
                        ) : null}
                        <button
                            className="w-96 h-12 px-4 border-none rounded-2xl bg-white font-sans text-xl font-semibold tracking-[0.1rem] text-[#707070] text-center"
                            onClick={phoneButtonPressed}
                        >
                            Sign in as Staff Spouse
                        </button>
                        {/* <button className="w-[22.5rem] h-12 mx-auto border-none rounded-2xl bg-transparent cursor-pointer" onClick={openRules}>
                            <div className="flex flex-row justify-center items-center pr-2">
                                <h2 className="font-sans font-normal text-base text-white m-0">View The Challenge Rules</h2>
                            </div>
                        </button> */}
                        <button className="border-none bg-transparent cursor-pointer font-sans text-base font-normal text-white" onClick={techTicket}>
                            Submit a Tech Ticket
                        </button>
                    </div>
                )}
                {registered === true && (
                    <div className="flex flex-col items-center">
                        <h1 className="font-sans font-bold m-0 text-white text-lg lg:text-4xl" id="countdownText">
                            You are registered!
                        </h1>
                    </div>
                )}
            </div>
            {isLoading === true ? <Loader /> : null}
        </div>
    );
}

export default Auth;
